import type {
  PatchAdminV1StoresStoreIdPoliciesIdBody,
  Policy,
  PolicyKind,
  PostAdminV1StoresStoreIdPoliciesBody,
} from '@nucleus-commerce/api-client/admin';

import { emptySeoOverride, fromSeoOverride, toSeoOverride } from '@/features/seo';

import type { PolicyFormInput, PolicyFormValues } from '../schemas/policy-form-schema';
import { defaultPolicyHandle } from '../schemas/policy-rules';

export function emptyPolicyForm(kind: PolicyKind = 'terms'): PolicyFormInput {
  return {
    kind,
    title: '',
    handle: defaultPolicyHandle(kind),
    summary: '',
    bodyHtml: '',
    status: 'draft',
    seo: emptySeoOverride(),
  };
}

export function fromPolicy(policy: Policy): PolicyFormInput {
  return {
    kind: policy.kind,
    title: policy.title,
    handle: policy.handle,
    summary: policy.summary ?? '',
    bodyHtml: policy.bodyHtml ?? '',
    status: policy.status,
    seo: fromSeoOverride(policy.seo),
  };
}

export function toPolicyCreate(values: PolicyFormValues): PostAdminV1StoresStoreIdPoliciesBody {
  const seo = toSeoOverride(values.seo);
  return {
    kind: values.kind,
    handle: values.handle,
    title: values.title,
    status: values.status,
    ...(values.summary ? { summary: values.summary } : {}),
    ...(values.bodyHtml.trim() ? { bodyHtml: values.bodyHtml } : {}),
    ...(seo ? { seo } : {}),
  };
}

/** Every editable field is sent; cleared text becomes null so the backend clears it too. */
export function toPolicyUpdate(values: PolicyFormValues): PatchAdminV1StoresStoreIdPoliciesIdBody {
  return {
    handle: values.handle,
    title: values.title,
    status: values.status,
    summary: values.summary || null,
    bodyHtml: values.bodyHtml.trim() ? values.bodyHtml : null,
    seo: toSeoOverride(values.seo),
  };
}
